import React, { useState } from "react";
import { Tabs } from "./Tabs";
import { useSearch } from "../../hooks";
import { BottomBlock } from "./BottomBlock";

export const BottomForm = () => {
  const { query } = useSearch<{ type: "buy" | "sell" }>({ defaultValues: { type: "buy" } });

  const [type, setType] = useState(query.type);

  const isBuyType = type === "buy";

  return (
    <section
      className="home_section"
      style={{ display: "flex", flexDirection: "column", gap: "30px", padding: "30px", backgroundColor: "#ffffff" }}
    >
      <Tabs isDark style={{ alignSelf: "flex-start" }} onChangeTab={setType} type={type} />

      <BottomBlock isBuyType={isBuyType} />
    </section>
  );
};
